export function normalizeMobile(mobile) {
    const raw = (mobile || '').trim();
    const digits = raw.replace(/\D/g, '');
    // Explicitly international: starts with + (non-Indian) or 00 followed by non-91 country code
    const isIntl =
        (raw.startsWith('+') && !raw.startsWith('+91')) ||
        (digits.startsWith('00') && !digits.startsWith('0091'));
    if (isIntl) return raw.replace(/\s/g, '');
    // Indian — strip known prefixes
    let indian = digits;
    if (indian.startsWith('0091') && indian.length === 14) indian = indian.slice(4);
    else if (indian.startsWith('91') && indian.length === 12) indian = indian.slice(2);
    else if (indian.startsWith('0') && indian.length === 11) indian = indian.slice(1);
    return indian;
}

export function isInternationalMobile(mobile) {
    const raw = (mobile || '').trim();
    const digits = raw.replace(/\D/g, '');
    return (raw.startsWith('+') && !raw.startsWith('+91')) ||
           (digits.startsWith('00') && !digits.startsWith('0091'));
}

export function getMobileError(mobile) {
    if (!mobile) return '';
    const normalized = normalizeMobile(mobile);
    if (!normalized) return '';
    const digitCount = normalized.replace(/\D/g, '').length;
    if (digitCount === 0) return '';
    if (isInternationalMobile(mobile)) return digitCount < 8 ? `Number too short — enter country code + number (min 8 digits)` : '';
    if (digitCount < 10) return `Number too short — ${digitCount} digit${digitCount === 1 ? '' : 's'} entered, need 10`;
    if (digitCount > 10) return `Number too long — ${digitCount} digits entered, Indian numbers must be 10 digits`;
    return '';
}
